<div
  #sensorFusionContainer
  class="sensor-fusion-container"
  [class.split-view]="isInSplitView$ | async"
>
  <mat-tab-group
    [dynamicHeight]="false"
    [mat-stretch-tabs]="false"
    (selectedTabChange)="onTabChanged()"
    [selectedIndex]="selectedIndex$ | async"
    (keydown)="handleKeyDownEvent($event)"
    #tabGroup
    class="sensor-fusion"
  >
    <mat-tab
      *ngFor="let output of validOutputs"
      aria-label="sensor-fusion-tab"
      #outputTab
    >
      <ng-template mat-tab-label>
        <div class="output-thumbnail-container">
          <div class="output-thumbnail-label">
            <strong class="output-thumbnail-label-text">{{
              output.name
            }}</strong>
          </div>
          <div class="output-thumbnail-content">
            <div
              class="pointer-overlay"
              [class.isSelected]="outputTab.isActive"
            >
              <div class="active-output" *ngIf="outputTab.isActive">
                <mat-icon>
                  <span class="material-symbols-outlined"> visibility </span>
                </mat-icon>
                <span>ACTIVE OUTPUT</span>
              </div>
              <ng-template
                h3ViewContainer
                [containerId]="buildThumbnailContainerId(output.name)"
                [viewId]="output.name"
              >
                <fa-icon
                  class="feedback-indicator"
                  *ngIf="
                    !outputTab.isActive &&
                    (hasFeedback[output.name] | async) &&
                    (isInSplitView$ | async) === false
                  "
                  [icon]="faCircle"
                ></fa-icon>
                <h3-naked-output [name]="output.name"></h3-naked-output>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-template>
      <div class="output-tab-content">
        <ng-container
          h3ViewContainer
          [containerId]="buildMainContainerId(output.name)"
        >
        </ng-container>
        <div class="small-margin">
          <h3-individual-field-scores
            [output]="output"
          ></h3-individual-field-scores>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<h3-split-view
  [class.split-view]="isInSplitView$ | async"
  [outputs]="validOutputs"
  *ngIf="taskWorkspaceStore$ | async"
></h3-split-view>
